// Matches a Swedish personnummer/samordningsnummer token: YYYYMMDD or
// YYYYMMDD- followed by 4 digits. The month and day aren't validated - the API
// looks the numbers up exactly and reports the ones it can't find, while a
// number rejected here would silently never be sent.
const PNR_TOKEN_REGEX = /(?:19|20)\d{6}-?\d{4}/g

export function normalizePnr(raw: string): string {
  return raw.replace(/-/g, '').trim()
}

// Scans free-form text for every PNR-shaped token and returns each as a
// normalized (hyphen-stripped) 12-digit string, in the order found.
// Duplicates are NOT removed here - that's the caller's decision.
export function extractPnrCandidates(text: string): string[] {
  if (!text) return []
  const matches = text.match(PNR_TOKEN_REGEX)
  return matches ? matches.map(normalizePnr) : []
}

// Removes every PNR-shaped token found by extractPnrCandidates() and returns
// the text left around them (e.g. a name or a partially typed personal
// number), with whitespace/comma/semicolon separators collapsed.
export function stripPnrCandidates(text: string): string {
  if (!text) return ''
  return text.replace(PNR_TOKEN_REGEX, ' ').replace(/[\s,;]+/g, ' ').trim()
}

// Reformats a normalized 12-digit PNR back to YYYYMMDD-XXXX for display.
export function formatPnr(normalized: string): string {
  return normalized.length === 12 ? `${normalized.slice(0, 8)}-${normalized.slice(8)}` : normalized
}
